import React from 'react';
import Context from "../../../tools/context";
import Coche from "../../../components/Coche";
import TicketsInfoPopup from "../../../components/Popup/TicketsPopup";
import {popupTypes} from "../../../Utils/Constants";
import {clientT} from "../../../tools/i18n";
import moment from 'moment';

const PassTickets = ({ticket, selected, handleSelection, promo, type}) => {
  const data = {};
  ticket?.campaignData?.forEach(d => (data[d.key] = d.value));

        // value = `https://cdn.cibler.io/campaigns/assets/${ticket.campaignId}/mobile${data.value}`;

  const [background, setBackground]
    = React.useState(`https://cdn.cibler.io/campaigns/assets/${ticket.campaignId}/mobile${data.background}`);

  const handleClick = () => {
    handleSelection && handleSelection(ticket);
  }
  const attributed = () => {
    if (!ticket.burnDate) return false;

    const date = new Date(ticket.burnDate);
    return <div style={{marginTop: '5px'}}>
      {clientT('usedTickets.affectedTo', {
        sellerRecipient: ticket.sellerRecipient,
        sellerRecipientId: ticket.sellerRecipientId,
        date: moment(date).format('DD/MM/YYYY'),
        hour: moment(date).format('HH:mm')
      })}
    </div>;
  }

  const height = () => {
    if (!data.height) return 'auto';

    if (!ticket.burnDate) return data.height;

    return `calc(${data.height} + 25px)`;
  }

  return (
    <div className="PassTickets"
      style={{
        backgroundImage: `url("${background}")`,
        backgroundColor: data.bgColor,
        borderColor: data.borderColor || 'transparent',
        borderWidth: '3px',
        borderStyle: 'solid',
        height: height(),
        color: data.textColor,
      }}
      onClick={handleClick}
    >
      <div dangerouslySetInnerHTML={{__html: data.condition}} />
      {attributed()}
      {handleSelection &&
        <Coche height="21px" width="21px" className="coche" color={data.textColor} selected={selected}/>
      }
      {background &&
      <div style={{display: 'none'}}><img
        src={background} onError={() => {
        setBackground('')
      }}
      /></div>
      }
    </div>
  )
}

export default PassTickets;